'use client'

import { memo } from 'react'

import ChartCardLoading from '@/components/charts/components/ChartCardLoading'

const ChartCollateralAtRiskLoading = () => {
  return (
    <ChartCardLoading
      className="gap-sm max-md:gap-[16px]"
      chartClassName="h-[172px] md:h-[223px]"
      titleClassName="w-[99px]"
      controls={['h-8 w-[76px] md:h-8 md:w-[101px]']}
      footer
    />
  )
}

export default memo(ChartCollateralAtRiskLoading)
